import { Reducer } from 'react';
import { BidHistoryActionEnum, BidHistoryActions, IBidHistoryState } from '.';

export const initialBidHistoryState: IBidHistoryState = {
  isOpen: false,
  submissionHistory: { loading: false, submissionHistoryItems: [] },
};

export const bidHistoryReducer: Reducer<IBidHistoryState, BidHistoryActions> = (
  state = initialBidHistoryState,
  action: BidHistoryActions
) => {
  switch (action.type) {
   
    case BidHistoryActionEnum.FetchSubmissionHistory:
      return {
        ...state,
        isOpen: true,
        submissionHistory: {
          ...state.submissionHistory,
          loading: action.state?.submissionHistory?.loading
            ? action.state?.submissionHistory?.loading
            : true,
          documentId: action.state?.submissionHistory?.documentId,
        },
      };
    case BidHistoryActionEnum.FetchedSubmissionHistorySuccessfully:
      return {
        ...state,
        submissionHistory: {
          ...state.submissionHistory,
          loading: action.state?.submissionHistory?.loading
            ? action.state?.submissionHistory?.loading
            : false,
          submissionHistoryItems:
            action.state?.submissionHistory?.submissionHistoryItems,
        },
      };
    case BidHistoryActionEnum.ClearSubmissionHistory:
      return {
        ...state,
        isOpen: false,
        submissionHistory: {
          ...state.submissionHistory,
          loading: action.state?.submissionHistory?.loading
          ? action.state?.submissionHistory?.loading
          : true,
          submissionHistoryItems: [],
        },
      };
    default:
      return state;
  }
};
